import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { logger } from '../../../lib/logging'
import { feathers as app } from '../../../feathers.js'
import PayButton from './PayButton.jsx'

const ReactivateAccountButton = ({
  team,
  onSuccess,
  reactivateImmediately
}) => {
  const [loading, setLoading] = useState(false)

  const reactivateAccount = useCallback(() => {
    setLoading(true)
    app
      .service('/api/subscription/reactivate')
      .create({ teamId: team.id })
      .then(onSuccess)
      .catch((err) =>
        logger.error('ReactivateAccountButton reactivateAccount err', err)
      )
      .finally(() => setLoading(false))
  }, [team, onSuccess])

  useEffect(() => {
    reactivateImmediately && reactivateAccount()
  }, [])

  return (
    <PayButton
      loading={loading}
      onClick={reactivateAccount}
      labelId='setting.subscription.reactivateButtonLabel'
    />
  )
}

ReactivateAccountButton.propTypes = {
  team: PropTypes.object.isRequired,
  onSuccess: PropTypes.func.isRequired,
  reactivateImmediately: PropTypes.bool
}

export default ReactivateAccountButton
